import { createContext } from "react";
export type { ContextValueType } from './typing';

export default createContext({})
